import { useEffect, useState } from 'react'

/**
 * Layout-matched page placeholder for lazy route chunks (spec 21 §3.9.1): a header band,
 * a KPI strip and table rows, so nothing reflows when the page arrives. Shown only after
 * 200ms — a fast load renders directly instead of flashing a skeleton.
 */
export function PageSkeleton({ delay = 200 }: { delay?: number }) {
  const [show, setShow] = useState(delay === 0)
  useEffect(() => {
    if (delay === 0) return
    const t = window.setTimeout(() => setShow(true), delay)
    return () => window.clearTimeout(t)
  }, [delay])
  if (!show) return null
  return (
    <div aria-busy="true" aria-label="Loading page" className="space-y-6">
      <div className="flex items-center gap-3.5">
        <div className="skeleton size-11 rounded-[10px]" />
        <div className="flex-1 space-y-2">
          <div className="skeleton h-5 w-48" />
          <div className="skeleton h-3 w-72 max-w-full" />
        </div>
      </div>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="card space-y-3 p-5">
            <div className="skeleton h-3 w-1/2" />
            <div className="skeleton h-6 w-1/3" />
          </div>
        ))}
      </div>
      <div className="card space-y-4 p-5">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="skeleton h-3" style={{ width: `${60 + ((i * 17) % 35)}%` }} />
        ))}
      </div>
    </div>
  )
}
